import type { SessionState } from './api/session';
import type { Screen } from './store/appStore';

// A session is required everywhere except a run already in progress: an offline import moves
// straight to the run screen without ever getting a session (see LoginScreen's
// "Szenariodatei importieren"), and that run must stay usable. Every other screen, including
// the editor, still needs a session.
export function needsLogin(sessionState: SessionState, screen: Screen, hasRun: boolean): boolean {
  const sessionMissing = sessionState === 'anonymous' || sessionState === 'offline';
  const runInProgress = screen === 'run' && hasRun;
  return sessionMissing && !runInProgress;
}
